import React from 'react';

// Mobile (APK) ChangePassword — full width.
export default function ChangePasswordMobile({ vm }) {
  const { user, mustChangePassword, defaultPassword, pw, setPw, confirm, setConfirm, show, setShow, busy, err, submit, doLogout, back } = vm;
  return (
    <div className="auth-mobile">
      <div className="auth-mobile-brand">{mustChangePassword ? 'Set your password' : 'Change password'}</div>
      <div className="muted auth-mobile-sub">
        {mustChangePassword
          ? <>Your password is still the default <strong>{defaultPassword}</strong>. Choose your own password to continue — it is required once.</>
          : <>Signed in as <strong>{user?.MobileNumber}</strong></>}
      </div>
      <form onSubmit={submit} className="auth-mobile-form">
        <label className="field">New password
          <input type={show ? 'text' : 'password'} value={pw} autoFocus autoComplete="new-password"
            placeholder="4–20 characters" onChange={(e) => setPw(e.target.value)} />
        </label>
        <label className="field">Confirm new password
          <input type={show ? 'text' : 'password'} value={confirm} autoComplete="new-password"
            onChange={(e) => setConfirm(e.target.value)} />
        </label>
        <label className="auth-mobile-check">
          <input type="checkbox" checked={show} onChange={(e) => setShow(e.target.checked)} />
          Show password
        </label>
        {err && <div className="auth-mobile-err">{err}</div>}
        <button className="btn primary auth-mobile-btn" disabled={busy}>
          {busy ? 'Saving…' : 'Save password'}
        </button>
      </form>
      <div className="auth-mobile-row">
        {!mustChangePassword && <button className="btn light" onClick={back}>Back</button>}
        <button className="btn light" onClick={doLogout}>Logout</button>
      </div>
    </div>
  );
}
